import vueLazyload from 'vue-lazyload'
import type { App } from 'vue'
export default function useVueLazyload(app: App) {
    app.use(vueLazyload, {
        lazyComponent: true,
        // set observer to true
        observer: true,

        // optional
        observerOptions: {
            rootMargin: '0px',
            threshold: 0.1
        }
    })
}